import Link from 'next/link'

export function NavigationList({ navigationLinks, style }) {
    return (
        <nav className={'NavigationList'}>
            <div className="d-flex align-items-center navigation-container" style={{...style}}>
                {navigationLinks.map((item) => {
                    // console.log(item);
                    return (
                        <Link href={item.href} key={item.name} className="item-nav">
                            {item.name}
                        </Link>
                    )
                })}
            </div>
        </nav>
    )
}
